import React, { useContext, useEffect } from 'react';
import { CategoryCard } from 'cartDrawer/components/CategoryCard/CategoryCard';
import 'components/ProductCards/ProductCard2022';
import { ProductCard } from 'cartDrawer/components/CategoryCard/ProductCard';
import { CartManagerCtx } from '../../../index';
export const EmptyStateBlock = () => {
    const cartManager = useContext(CartManagerCtx);
    const categories = cartManager.categories;
    const products = cartManager.products;
    const alternateLayout = cartManager.alternateVersion;
    let innerLayout = (React.createElement("div", { className: "flex flex-grow my-11 px-4 flex-wrap w-full" }, categories
        .filter(category => category.link && category.title)
        .map((category, key) => (React.createElement(CategoryCard, Object.assign({ key: key }, category))))));
    if (alternateLayout) {
        innerLayout = (React.createElement("div", { className: "flex-grow my-11 glide cart-empty-state product-card-carousel" },
            React.createElement("div", { className: "glide__track", "data-glide-el": "track" },
                React.createElement("ul", { className: "glide__slides list-none product-card-carousel-slides" }, products.map((product, key) => {
                    const firstVariant = product.variants[0];
                    return (React.createElement("li", { key: key, className: "glide__slide product-card-carousel-{{ random }}-slide" },
                        React.createElement(ProductCard, { available: firstVariant.available /* @ts-ignore */, id: product.id /* @ts-ignore */, image: product.featured_image, link: `/products/${product.handle}`, price: firstVariant.price /* @ts-ignore */, tags: product.tags /* @ts-ignore */, title: product.title, variantId: firstVariant.id })));
                })))));
        useEffect(() => {
            new globalThis.Glide('.glide.cart-empty-state.product-card-carousel', {
                gap: 16,
                peek: 85,
                type: 'carousel',
            }).mount();
        }, []);
    }
    return (React.createElement("div", { className: "flex flex-col items-center my-4" },
        React.createElement("div", { className: "text-[#183F86] font-abc-monument-grotesk font-medium text-2xl" }, cartManager.emptyStateTitle),
        React.createElement("div", { className: "font-medium text-sm font-abc-monument-grotesk text-medium-gray" }, cartManager.emptyStateSubtitle),
        innerLayout,
        React.createElement("div", { className: "w-full py-3 px-4" },
            React.createElement("div", null,
                React.createElement("a", { className: "vital-btn font-abc-monument-grotesk w-full", href: cartManager.emptyStateCTALink }, cartManager.emptyStateCTAText)),
            React.createElement("div", { className: "mt-3 text-[#183F86] font-abc-monument-grotesk font-medium text-base text-center" }, cartManager.emptyStateCTASubtext))));
};
export default EmptyStateBlock;
